module.exports = __webpack_public_path__ + "static/media/copy-ic.d2bedc38.svg";